module.exports = __webpack_public_path__ + "img/icon-setting-blue.13af02d0.png";